
import { createContext, useContext } from "react";
import { Session, User } from "@supabase/supabase-js";
import { signInWithMicrosoft, signOut as authSignOut } from "@/services/authService";
import { useAuthState, TenantType, AuthStatus } from "@/hooks/useAuthState";

interface AuthContextType {
  session: Session | null;
  user: User | null;
  tenantId: string | null;
  tenantType: TenantType | null;
  isLoading: boolean;
  authStatus: AuthStatus;
  signInWithMicrosoft: (redirectTo: string, redirectQueryParams?: Record<string, string>) => Promise<void>;
  signOut: () => Promise<void>;
  refreshAuthStatus: () => Promise<void>;
  isInitialLoad: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuthState();

  return (
    <AuthContext.Provider
      value={{
        ...auth,
        signInWithMicrosoft,
        signOut: authSignOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
